// import React, { useState, useEffect } from 'react';
// import { database, auth } from '../firebase';
// import { ref, push, onValue, update, remove, off, serverTimestamp } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';

// const EmployeeRole = () => {
//   const [roleName, setRoleName] = useState('');
//   const [description, setDescription] = useState('');
//   const [loginType, setLoginType] = useState('Main Login');
//   const [roles, setRoles] = useState([]);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [showForm, setShowForm] = useState(false);
//   const [editingRole, setEditingRole] = useState(null);

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       if (!user) {
//         setRoles([]);
//         setLoading(false);
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (!currentUser) return;

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     const rolesRef = ref(database, `users/${encodedEmail}/roles`);

//     const handleData = (snapshot) => {
//       const rolesData = [];
//       snapshot.forEach((childSnapshot) => {
//         rolesData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val(),
//         });
//       });
//       setRoles(rolesData);
//       setLoading(false);
//     };

//     const handleError = (error) => {
//       console.error("Error fetching roles:", error);
//       setError("Failed to fetch roles");
//       setLoading(false);
//     };

//     onValue(rolesRef, handleData, handleError);

//     return () => {
//       off(rolesRef, 'value', handleData);
//     };
//   }, [currentUser]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!currentUser) {
//       setError('You must be logged in to manage roles');
//       return;
//     }

//     if (!roleName.trim()) {
//       setError('Role name is required');
//       return;
//     }

//     try {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const rolesRef = ref(database, `users/${encodedEmail}/roles`);
//       const roleData = {
//         roleName: roleName.trim(),
//         description: description.trim(),
//         loginType,
//         updatedAt: serverTimestamp(),
//         updatedBy: currentUser.email,
//       };

//       if (editingRole) {
//         const roleRef = ref(database, `users/${encodedEmail}/roles/${editingRole.id}`);
//         await update(roleRef, roleData);
//         setError('Role updated successfully!');
//       } else {
//         roleData.createdAt = serverTimestamp();
//         roleData.createdBy = currentUser.email;
//         await push(rolesRef, roleData);
//         setError('Role added successfully!');
//       }

//       handleResetForm();
//       setShowForm(false);
//     } catch (err) {
//       setError('Failed to save role');
//       console.error(err);
//     }
//   };

//   const handleEdit = (role) => {
//     setEditingRole(role);
//     setRoleName(role.roleName);
//     setDescription(role.description || '');
//     setLoginType(role.loginType);
//     setShowForm(true);
//   };

//   const handleDelete = async (roleId) => {
//     if (!currentUser) return;
//     if (window.confirm("Are you sure you want to delete this role?")) {
//       try {
//         const encodedEmail = encodeEmailForPath(currentUser.email);
//         const roleRef = ref(database, `users/${encodedEmail}/roles/${roleId}`);
//         await remove(roleRef);
//       } catch (error) {
//         setError("Error deleting role: " + error.message);
//         console.error(error);
//       }
//     }
//   };

//   const handleResetForm = () => {
//     setRoleName('');
//     setDescription('');
//     setLoginType('Main Login');
//     setError('');
//     setEditingRole(null);
//     setShowForm(false);
//   };

//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '2rem auto',
//       padding: '2rem',
//       minHeight: '100vh',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '2rem',
//       padding: '1.5rem',
//       backgroundColor: 'white',
//       borderRadius: '6px',
//       border: '1px solid #d1d5db',
//       fontWeight: '600',
//       color: '#374151',
//     },
//     title: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#2563eb',
//       margin: '0',
//     },
//     addButton: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//       backgroundColor: '#2563eb',
//     },
//     tableContainer: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       overflow: 'hidden',
//       boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       overflowX: 'auto',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.9rem',
//       border: '1px solid #d1d5db',
//     },
//     tableHeader: {
//       padding: '1rem 0.75rem',
//       textAlign: 'center',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.85rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//     },
//     tableCell: {
//       padding: '1rem 0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//       textAlign: 'center',
//     },
//     noData: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#718096',
//       fontSize: '1.1rem',
//     },
//     srNoCell: {
//       fontWeight: '600',
//       color: '#2563eb',
//       textAlign: 'center',
//       width: '60px',
//     },
//     actionCell: {
//       display: 'flex',
//       gap: '0.5rem',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: '0.5rem',
//     },
//     editButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//       transform: 'translateY(0)',
//     },
//     deleteButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
//       transform: 'translateY(0)',
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '20px',
//       padding: '2.5rem',
//       border: '1px solid #e2e8f0',
//     },
//     formHeading: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       marginBottom: '2rem',
//       color: '#1f2937',
//       textAlign: 'center',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.875rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     button: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//     },
//     submitButton: {
//       backgroundColor: '#10b981',
//       color: 'white',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//     },
//   };

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={{ textAlign: 'center', padding: '4rem', color: '#718096', fontSize: '1.1rem' }}>
//           <h2>Please login to access Employee Roles</h2>
//         </div>
//       </div>
//     );
//   }

//   if (showForm) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.formWrapper}>
//           <h1 style={styles.formHeading}>👤 {editingRole ? 'Edit Role' : 'Add New Role'}</h1>

//           {error && (
//             <div style={error.includes('successfully') ? styles.messageSuccess : styles.messageError}>
//               <span>{error.includes('successfully') ? '✅' : '❌'}</span>
//               {error}
//             </div>
//           )}

//           {loading ? (
//             <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#6b7280' }}>
//               <div style={{
//                 width: '3rem',
//                 height: '3rem',
//                 border: '4px solid #e5e7eb',
//                 borderTop: '4px solid #2563eb',
//                 borderRadius: '50%',
//                 animation: 'spin 1s linear infinite',
//                 margin: '0 auto 1rem',
//               }}></div>
//               <p>Loading form data...</p>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '2rem' }}>
//                 <div style={{
//                   backgroundColor: '#fff',
//                   padding: '1.5rem',
//                   borderRadius: '8px',
//                   border: '1px solid #e2e8f0',
//                   boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//                 }}>
//                   <h2 style={{
//                     fontSize: '1.25rem',
//                     fontWeight: '600',
//                     marginBottom: '1rem',
//                     color: '#1f2937',
//                   }}>📋 Role Information</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>
//                       Role Name<span style={styles.requiredAsterisk}>*</span>
//                     </label>
//                     <input
//                       type="text"
//                       value={roleName}
//                       onChange={(e) => setRoleName(e.target.value)}
//                       style={styles.input}
//                       placeholder="Enter role name"
//                       required
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Description</label>
//                     <input
//                       type="text"
//                       value={description}
//                       onChange={(e) => setDescription(e.target.value)}
//                       style={styles.input}
//                       placeholder="Enter description"
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Login Type</label>
//                     <select
//                       value={loginType}
//                       onChange={(e) => setLoginType(e.target.value)}
//                       style={styles.select}
//                     >
//                       <option value="Main Login">Main Login</option>
//                       <option value="Sub Login">Sub Login</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//               <div style={styles.buttonContainer}>
//                 <button
//                   type="button"
//                   onClick={handleResetForm}
//                   style={{ ...styles.button, ...styles.cancelButton }}
//                   disabled={loading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   style={{ ...styles.button, ...styles.submitButton }}
//                   disabled={loading}
//                 >
//                   {editingRole ? 'Update Role' : 'Add Role'}
//                 </button>
//               </div>
//             </form>
//           )}
//         </div>
//         <style jsx>{`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//           input:focus,
//           select:focus {
//             outline: none;
//             border-color: #2563eb;
//             box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
//           }
//           input:hover,
//           select:hover {
//             border-color: #a1a1aa;
//           }
//           button:hover:not(:disabled) {
//             filter: brightness(90%);
//           }
//         `}</style>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Employee Roles</h1>
//         <button
//           onClick={() => setShowForm(true)}
//           style={styles.addButton}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//         >
//           + Add Role
//         </button>
//       </div>

//       <div style={styles.tableContainer}>
//         {loading ? (
//           <div style={{ textAlign: 'center', padding: '4rem', color: '#718096', fontSize: '1.1rem' }}>
//             <p>⏳ Loading roles...</p>
//           </div>
//         ) : roles.length > 0 ? (
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={{ ...styles.tableHeader, ...styles.srNoCell }}>S.No</th>
//                 <th style={styles.tableHeader}>Role Name</th>
//                 <th style={styles.tableHeader}>Description</th>
//                 <th style={styles.tableHeader}>Login Type</th>
//                 <th style={styles.tableHeader}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {roles.map((role, index) => (
//                 <tr
//                   key={role.id}
//                   style={{
//                     backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
//                   <td style={styles.tableCell}>{role.roleName}</td>
//                   <td style={styles.tableCell}>{role.description || '-'}</td>
//                   <td style={styles.tableCell}>{role.loginType}</td>
//                   <td style={{ ...styles.tableCell, ...styles.actionCell }}>
//                     <button
//                       onClick={() => handleEdit(role)}
//                       style={styles.editButton}
//                       title="Edit"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                       }}
//                     >
//                       ✏️
//                     </button>
//                     <button
//                       onClick={() => handleDelete(role.id)}
//                       style={styles.deleteButton}
//                       title="Delete"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                       }}
//                     >
//                       🗑️
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <div style={styles.noData}>
//             <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>📁</div>
//             <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Roles Found</h3>
//             <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first role!</p>
//             <button
//               onClick={() => setShowForm(true)}
//               style={{
//                 ...styles.addButton,
//                 fontSize: '1rem',
//                 padding: '1rem 2rem',
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-2px)';
//                 e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               + Add Your First Role
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EmployeeRole;

import React, { useState, useEffect } from 'react';
import { database, auth } from '../firebase';
import { ref, push, onValue, update, remove, off, serverTimestamp } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';

const EmployeeRole = () => {
  const [roleName, setRoleName] = useState('');
  const [description, setDescription] = useState('');
  const [loginType, setLoginType] = useState('Main Login');
  const [roles, setRoles] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingRole, setEditingRole] = useState(null);

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (!user) {
        setRoles([]);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!currentUser) return;

    const encodedEmail = encodeEmailForPath(currentUser.email);
    const rolesRef = ref(database, `users/${encodedEmail}/roles`);

    const handleData = (snapshot) => {
      const rolesData = [];
      snapshot.forEach((childSnapshot) => {
        rolesData.push({
          id: childSnapshot.key,
          ...childSnapshot.val(),
        });
      });
      setRoles(rolesData);
      setLoading(false);
    };

    const handleError = (error) => {
      console.error("Error fetching roles:", error);
      setError("Failed to fetch roles");
      setLoading(false);
    };

    onValue(rolesRef, handleData, handleError);

    return () => {
      off(rolesRef, 'value', handleData);
    };
  }, [currentUser]);

  const validateRoleName = (name) => {
    // Allow only letters and spaces
    return /^[A-Za-z\s]*$/.test(name);
  };

  const handleRoleNameChange = (e) => {
    const value = e.target.value;
    if (validateRoleName(value)) {
      setRoleName(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!currentUser) {
      setError('You must be logged in to manage roles');
      return;
    }

    if (!roleName.trim()) {
      setError('Role name is required');
      return;
    }

    try {
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const rolesRef = ref(database, `users/${encodedEmail}/roles`);
      const roleData = {
        roleName: roleName.trim(),
        description: description.trim(),
        loginType,
        updatedAt: serverTimestamp(),
        updatedBy: currentUser.email,
      };

      if (editingRole) {
        const roleRef = ref(database, `users/${encodedEmail}/roles/${editingRole.id}`);
        await update(roleRef, roleData);
        alert('Role Updated Successfully.');
      } else {
        roleData.createdAt = serverTimestamp();
        roleData.createdBy = currentUser.email;
        await push(rolesRef, roleData);
        alert('New Role Added Successfully.');
      }

      handleResetForm();
      setShowForm(false);
    } catch (err) {
      setError('Failed to save role');
      console.error(err);
    }
  };

  const handleEdit = (role) => {
    setEditingRole(role);
    setRoleName(role.roleName);
    setDescription(role.description || '');
    setLoginType(role.loginType);
    setShowForm(true);
  };

  const handleDelete = async (roleId) => {
    if (!currentUser) return;
    if (window.confirm("Are you sure you want to delete this role?")) {
      try {
        const encodedEmail = encodeEmailForPath(currentUser.email);
        const roleRef = ref(database, `users/${encodedEmail}/roles/${roleId}`);
        await remove(roleRef);
      } catch (error) {
        setError("Error deleting role: " + error.message);
        console.error(error);
      }
    }
  };

  const handleResetForm = () => {
    setRoleName('');
    setDescription('');
    setLoginType('Main Login');
    setError('');
    setEditingRole(null);
    setShowForm(false);
  };

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '2rem auto',
      padding: '2rem',
      minHeight: '100vh',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '2rem',
      padding: '1.5rem',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #d1d5db',
      fontWeight: '600',
      color: '#374151',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#2563eb',
      margin: '0',
    },
    addButton: {
      padding: '0.875rem 2rem',
      borderRadius: '8px',
      color: 'white',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
      transform: 'translateY(0)',
      backgroundColor: '#2563eb',
    },
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem',
      border: '1px solid #d1d5db',
    },
    tableHeader: {
      padding: '1rem 0.75rem',
      textAlign: 'center',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.85rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      border: '1px solid #1e40af',
    },
    tableCell: {
      padding: '1rem 0.75rem',
      border: '1px solid #d1d5db',
      color: '#374151',
      verticalAlign: 'middle',
      textAlign: 'center',
    },
    noData: {
      textAlign: 'center',
      padding: '4rem 2rem',
      color: '#718096',
      fontSize: '1.1rem',
    },
    srNoCell: {
      fontWeight: '600',
      color: '#2563eb',
      textAlign: 'center',
      width: '60px',
    },
      srNoCell1: {
      fontWeight: '600',
      color: '#fff',
      textAlign: 'center',
      width: '60px',
    },
    actionCell: {
      display: 'flex',
      gap: '0.5rem',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0.5rem',
    },
    editButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#10b981',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
      transform: 'translateY(0)',
    },
    deleteButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#ef4444',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
      transform: 'translateY(0)',
    },
    formWrapper: {
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '2.5rem',
      border: '1px solid #e2e8f0',
    },
    formHeading: {
      fontSize: '2rem',
      fontWeight: '700',
      marginBottom: '2rem',
      color: '#1f2937',
      textAlign: 'center',
    },
    messageSuccess: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #a7f3d0',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    messageError: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      border: '1px solid #fecaca',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    inputGroup: {
      marginBottom: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      display: 'block',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '0.25rem',
    },
    requiredAsterisk: {
      color: '#ef4444',
      marginLeft: '0.25rem',
    },
    input: {
      display: 'block',
      width: '100%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      transition: 'border-color 0.2s ease',
    },
    select: {
      display: 'block',
      width: '100%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1em 1em',
      paddingRight: '2rem',
    },
    buttonContainer: {
      marginTop: '2rem',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
      paddingTop: '1rem',
      borderTop: '1px solid #e2e8f0',
    },
    button: {
      padding: '0.5rem 1.5rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.2s ease',
    },
    submitButton: {
      backgroundColor: '#10b981',
      color: 'white',
    },
    cancelButton: {
      backgroundColor: '#ef4444',
      color: 'white',
    },
  };

  if (!currentUser) {
    return (
      <div style={styles.container}>
        <div style={{ textAlign: 'center', padding: '4rem', color: '#718096', fontSize: '1.1rem' }}>
          <h2>Please login to access Employee Roles</h2>
        </div>
      </div>
    );
  }

  if (showForm) {
    return (
      <div style={styles.container}>
        <div style={styles.formWrapper}>
          <h1 style={styles.formHeading}>👤 {editingRole ? 'Edit Role' : 'Add New Role'}</h1>

          {error && (
            <div style={error.includes('successfully') ? styles.messageSuccess : styles.messageError}>
              <span>{error.includes('successfully') ? '✅' : '❌'}</span>
              {error}
            </div>
          )}

          {loading ? (
            <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#6b7280' }}>
              <div style={{
                width: '3rem',
                height: '3rem',
                border: '4px solid #e5e7eb',
                borderTop: '4px solid #2563eb',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 1rem',
              }}></div>
              <p>Loading form data...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '2rem' }}>
                <div style={{
                  backgroundColor: '#fff',
                  padding: '1.5rem',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                }}>
                  <h2 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#1f2937',
                  }}>📋 Role Information</h2>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>
                      Role Name<span style={styles.requiredAsterisk}>*</span>
                    </label>
                    <input
                      type="text"
                      value={roleName}
                      onChange={handleRoleNameChange}
                      style={styles.input}
                      placeholder="Enter role name (letters only)"
                      required
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Description</label>
                    <input
                      type="text"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      style={styles.input}
                      placeholder="Enter description"
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Login Type</label>
                    <select
                      value={loginType}
                      onChange={(e) => setLoginType(e.target.value)}
                      style={styles.select}
                    >
                      <option value="Main Login">Main Login</option>
                      <option value="Sub Login">Sub Login</option>
                    </select>
                  </div>
                </div>
              </div>
              <div style={styles.buttonContainer}>
                <button
                  type="button"
                  onClick={handleResetForm}
                  style={{ ...styles.button, ...styles.cancelButton }}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{ ...styles.button, ...styles.submitButton }}
                  disabled={loading}
                >
                  {editingRole ? 'Update Role' : 'Add Role'}
                </button>
              </div>
            </form>
          )}
        </div>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          input:focus,
          select:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
          }
          input:hover,
          select:hover {
            border-color: #a1a1aa;
          }
          button:hover:not(:disabled) {
            filter: brightness(90%);
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Employee Roles</h1>
        <button
          onClick={() => setShowForm(true)}
          style={styles.addButton}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
          }}
        >
          + Add Role
        </button>
      </div>

      <div style={styles.tableContainer}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '4rem', color: '#718096', fontSize: '1.1rem' }}>
            <p>⏳ Loading roles...</p>
          </div>
        ) : roles.length > 0 ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, ...styles.srNoCell1 }}>Sr.No</th>
                <th style={styles.tableHeader}>Role Name</th>
                <th style={styles.tableHeader}>Description</th>
                <th style={styles.tableHeader}>Login Type</th>
                <th style={styles.tableHeader}>Action</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role, index) => (
                <tr
                  key={role.id}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
                  <td style={styles.tableCell}>{role.roleName}</td>
                  <td style={styles.tableCell}>{role.description || '-'}</td>
                  <td style={styles.tableCell}>{role.loginType}</td>
                  <td style={{ ...styles.tableCell, ...styles.actionCell }}>
                    <button
                      onClick={() => handleEdit(role)}
                      style={styles.editButton}
                      title="Edit"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
                      }}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(role.id)}
                      style={styles.deleteButton}
                      title="Delete"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
                      }}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={styles.noData}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>📁</div>
            <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Roles Found</h3>
            <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first role!</p>
            <button
              onClick={() => setShowForm(true)}
              style={{
                ...styles.addButton,
                fontSize: '1rem',
                padding: '1rem 2rem',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
              }}
            >
              + Add Your First Role
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeRole;